import "./common.ts";
import "../portico/legacy_header.ts";
import "../portico/google-analytics.ts";
import "../portico/portico_modals.ts";
import "../portico/tippyjs.ts";
import "../../third/bootstrap/css/bootstrap.portico.css";
import "../../styles/portico/legacy_portico_styles_bundle.css";
import "tippy.js/dist/tippy.css";
